import React from 'react'
import styled from 'styled-components'

const StatementStatBar = ({result, useTranslate, size = "lg", barColor = "#F58220"}) => {

  const width = result !== null ? result : 0;
  const outside = width < 10;
  const active = true;

  return (
    <BarContainer className={`statement-stat-bar statement-stat-bar-${size} ${result === null && "no-value"}`}>
      <SliderBg className={`${result !== null && "has-value"}`} barColor={barColor} />
      <SliderSteps className={`${result === null && "no-value"}`}>
        <SliderResultIndicator className="slider-result-indicator" style={{ left: `${result || 0}%` }} barColor={barColor} />
        <SliderDot className="slider-dot-1" />
        <SliderDot className="slider-dot-2" />
        <SliderDot className="slider-dot-3" />
        <SliderDot className="slider-dot-4" />
        <SliderDot className="slider-dot-5" />
      </SliderSteps>
      <ResultBarContainer className={`${result >= 0 && "has-value"}`}>
        <ResultBar
          className={`${active && "active"} ${outside && "outside"}`}
          style={{ width: `${width || 0}%` }}
          barColor={barColor}
        >
                <span className={`position-relative detail ${result === null && "no-value"} ${outside && "outside"}`}>
                  {result !== null ? result.toFixed(0) + "%" : useTranslate("data_vault.does_not_concern")}
                </span>
        </ResultBar>
      </ResultBarContainer>
    </BarContainer>
  )
}

export default StatementStatBar;

const BarContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  flex-shrink: 0;
  height: 42px;
  overflow: visible;
  border-radius: 10px;
  background: none;
  
  .no-value .slider-steps {
    display: none;
  }
  
  &.statement-stat-bar-sm {
    height: 36px;
  }
`;

const ResultBarContainer = styled.div`
  position: relative;
  width: calc(100% - 48px);
  margin-left: 24px;
`;

const ResultBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.barColor};
  height: 100%;
  border-radius: 10px;
  font-weight: 500;
  color: white;
  z-index: 2;
  height: 100%;
  
  .detail {
    position: relative;
    z-index: 4;
    left: -9px;
  }
  
  .detail.outside {
    left: calc(100% + 35px);
  }
  
  .detail.no-value.outside {
    left: -9px;
  }
  
  span {
    white-space: nowrap;
  }
  
  span.no-value {
    opacity: .5;
    font-size: 13px;
  }
  
  &.outside span {
    color: black;
  }
`;

const SliderBg = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 21px;
  background-color: #F4F3F1;
  overflow: hidden;
    
  &.has-value:before {
    position: relative;
    display: block;
    content: '';
    width: 34px;
    height: 100%;
    background-color: ${(props) => props.barColor};
    z-index: 2;
  }
`;

const SliderSteps = styled.div`
  position: absolute;
  left: 24px;
  top: 0;
  width: calc(100% - 48px);
  height: 100%;
  
  &.no-value {
    display: none;
  }
`;

const SliderResultIndicator = styled.span`
  position: absolute;
  top: 50%;
  display: block;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
  z-index: 3;
  background: linear-gradient(44.73deg, #F4F3F1 11.32%, #F4F3F1 98.96%);
  border: 1px solid #EEEEEE;
  box-shadow: inset -4px 4px 3px #F0EEEB;
  
  &:after {
    display: block;
    content: ' ';
    background: ${(props) => props.barColor};
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    border-radius: 50%;
    height: 32px;
    width: 32px;
    position: absolute;
  }
`;

const SliderDot = styled.span`
  position: absolute;
  z-index: 1;
  width: 0;
  height: 0;
  border: 0;
  top: 50%;
  background: #656579;
  opacity: .5;
  
  &::before {
    position: absolute;
    content: ' ';
    width: 24px;
    height: 24px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: linear-gradient(-44.73deg, #EEF1F5 11.32%, #E6E9EF 92.96%);
    box-shadow: inset -4px -4px 9px rgba(255,255,255,0.7), inset 4px 4px 5px rgba(166,180,200,0.7);
  }
  
  &:after {
    position: absolute;
    content: ' ';
    width: 12px;
    height: 12px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: linear-gradient(44.73deg, #EEF1F5 11.32%, #E6E9EF 92.96%);
    box-shadow: inset 4px 4px 9px rgba(255,255,255,0.7), inset -4px -4px 5px rgba(166,180,200,0.7);
  }
  
  &.slider-dot-1 {
    left: 0;
  }  
  &.slider-dot-2 {
    left: 25%;
  }
  &.slider-dot-3 {
    left: 50%;
  }
  &.slider-dot-4 {
    left: 75%;
  }
  &.slider-dot-5 {
    left: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui/statement-stat-bar.js